module.exports = __webpack_public_path__ + "img/banner3.b679d84d.png";